<template>
  <div
    class="logosSliderSection"
    :class="{
      'logosSliderSection--white': data.WhiteBackground,
    }"
  >
    <div class="container">
      <SectionContainer :title="data.Title" :small-center-title="data.SmallCenterTitle">
        <div class="logosSliderSection__content">
          <SliderLogotypes :items="items" :size="slideSize" />
        </div>
      </SectionContainer>
    </div>
  </div>
</template>

<script>
import SectionContainer from '@/components/SectionContainer.vue';
import SliderLogotypes from '@/components/Sliders/SliderLogotypes.vue';

export default {
  name: 'LogosSliderSection',
  components: { SliderLogotypes, SectionContainer },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    slideSize() {
      if (!this.data.ElementsInSlider) {
        return 'normal';
      }
      if (this.data.ElementsInSlider === 5) {
        return 'big';
      }
      if (this.data.ElementsInSlider === 7) {
        return 'normal';
      }
      if (this.data.ElementsInSlider === 9) {
        return 'small';
      }

      return 'normal';
    },
    items() {
      return this.data.Logos.map(({ Icon, IconAlt }) => ({
        name: IconAlt,
        image: Icon ? JSON.parse(Icon).url : '',
      }));
    },
  },
};
</script>

<style scoped lang="scss">
.logosSliderSection {
  $root: &;
  padding: 2rem 0;

  &--white {
    background: $cWhite;
  }

  &__content {
    margin: 2rem 0 0;
  }
}
</style>
